import { render, staticRenderFns } from "./roleNotice.vue?vue&type=template&id=25087661&scoped=true"
import script from "./roleNotice.vue?vue&type=script&lang=js"
export * from "./roleNotice.vue?vue&type=script&lang=js"
import style0 from "./roleNotice.vue?vue&type=style&index=0&id=25087661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25087661",
  null
  
)

export default component.exports